import { render, staticRenderFns } from "./v-dragdrop-field.vue?vue&type=template&id=17afbbab"
import script from "./v-dragdrop-field.vue?vue&type=script&lang=js"
export * from "./v-dragdrop-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports